import { createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const submitPartnerForm = createAsyncThunk("submitPartnerForm", async (data, { rejectWithValue }) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } }
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/website/add_partner`,
      data,
      config
    )
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export { submitPartnerForm }
